<!-- 获取停车场所有月票信息接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: { "parkCode":"2KNTYVWC","carNo":"粤Y12345","pageNum":"1","pageSize":"10"},
            responseCode: 	{"data":{"monthCardList":[{"carNo":"粤Y12345","begin":"20180901000000","end":"20181001235959",
                  "totalDiscountPrice":10.00,"totalOriginalPrice":10.00,"customVipName":"测试VIP","settlementAmount":0,
                  "customerTelphone":"13655545425","settlementType":0,"operator":"operator","customerName":"隔壁老王",
                  "remark":"20181008080808"}],"total":1},"message":"业务成功","resultCode":0,"status":1},
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台获取停车场所有月票信息接口",
                t_url: this.commonUrls.test+"getMonthCardList",
                p_url: this.commonUrls.prod+"getMonthCardList",
                precondition: "无",
                fitSystem: "VEMS传统停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' },
                      { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'carNo', info2: '否', info3: 'String', info4: '车牌号码' },
                        { info1: 'pageNum', info2: '否', info3: 'Integer', info4: '第几页，从1开始' },
                        { info1: 'pageSize', info2: '否', info3: 'Integer', info4: '每页多少条，最多1000条' }
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' },
                      { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'total', info2: '是', info3: 'Integer', info4: '记录总条数' },
                        { info1: 'monthCardList', info2: '是', info3: 'JSONArray', info4: '月卡记录列表' }
                        ]
                },{
                    titleName: 'monthCardList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' },
                      { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'carNo', info2: '是', info3: 'String', info4: '车牌号码' },
                        { info1: 'begin', info2: '是', info3: 'String', info4: '月卡开始时间' },
                        { info1: 'end', info2: '是', info3: 'String', info4: '月卡结束时间' },
                        { info1: 'totalDiscountPrice', info2: '是', info3: 'BigDecimal', info4: '月票折扣价格' },
                        { info1: 'totalOriginalPrice', info2: '是', info3: 'BigDecimal', info4: '月票原始价格' },
                        { info1: 'customVipName', info2: '是', info3: 'String', info4: 'VIP类型名称' },
                        { info1: 'settlementAmount', info2: '是', info3: 'BigDecimal',
                          info4: '结算类型为0则为月卡单价，结算类型为1则为余额，结算类型为2则为剩余次数' },
                        { info1: 'customerTelphone', info2: '是', info3: 'String', info4: '车主电话' },
                        { info1: 'settlementType', info2: '是', info3: 'Integer', info4: '0时间结算，1余额结算，2次数结算' },
                        { info1: 'operator', info2: '是', info3: 'String', info4: '操作员' },
                        { info1: 'customerName', info2: '是', info3: 'String', info4: '车主姓名' },
                        { info1: 'remark', info2: '是', info3: 'String', info4: '备注（操作时间）' }
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/deprecated/vip/getMonthCardList.vue